import { Tab, Tabs } from 'react-bootstrap';
import { Container } from 'react-bootstrap';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
import EdoDashboardOverview from './EdoDashboardOverview';
import EdoDashboardApprovals from './EdoDashboardApprovals';
import Dashboard from 'components/global/Dashboard/Dashboard';
const EdoDashboard = () => {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      page: location.pathname,
      title: 'EDO Dashboard',
    });
  }, [location.pathname]);

  return (
    <Container fluid className="px-0">
      <Tabs defaultActiveKey="overview">
        <Tab eventKey="overview" title="Overview">
          <EdoDashboardOverview />
        </Tab>
        <Tab eventKey="approvals" title="Approvals" mountOnEnter>
          <EdoDashboardApprovals />
        </Tab>
        <Tab eventKey="charts" title="Charts" mountOnEnter>
          <Dashboard embedded />
        </Tab>
      </Tabs>
    </Container>
  );
};

export default EdoDashboard;
